import React from "react";
import type { NewStudent } from "../../contexts/HackathonContext";
import { groups } from "../../data/groups";
import { PhotoInput } from "./PhotoInput";
import { inputClass, labelClass } from "./fieldStyles";
interface StudentFieldsProps {
  value: NewStudent;
  onChange: (value: NewStudent) => void;
  mode: "self" | "admin";
}
export function StudentFields({
  value,
  onChange,
  mode
}: StudentFieldsProps) {
  const set = <K extends keyof NewStudent,>(key: K, v: NewStudent[K]) => onChange({
    ...value,
    [key]: v
  });
  return <div className="space-y-5" data-id="element-248" data-mp="3mxg1fiewn8mf">
      <PhotoInput name={value.name} school={value.school} value={value.photo} onChange={p => set("photo", p)} data-id="element-249" data-mp="3mz8yc5zpueh8" />

      <label className="block" data-id="element-250" data-mp="3e4uju5n0f7z6">
        <span className={labelClass} data-id="element-251" data-mp="3e3jisdky8ebr">Full name</span>
        <input required value={value.name} onChange={e => set("name", e.target.value)} className={inputClass} data-id="element-252" data-mp="3e2rt1je19ate" />
      </label>

      <div className="grid gap-5 sm:grid-cols-2" data-id="element-253" data-mp="9puuct1f3rf8">
        <label className="block" data-id="element-254" data-mp="9o9watfw9qcm">
          <span className={labelClass} data-id="element-255" data-mp="jqo3l4i9gxn1">University</span>
          <select value={value.school} onChange={e => set("school", e.target.value as NewStudent["school"])} className={inputClass} data-id="element-256" data-mp="jr65agnp042c">
            <option value="link" data-id="element-257" data-mp="9ztelsdmrjxw">Link School of Business · Brazil</option>
            <option value="mahindra" data-id="element-258" data-mp="eyw94ivzi7rm">Mahindra University · India</option>
          </select>
        </label>
        {mode === "admin" ? <label className="block" data-id="element-259" data-mp="ylfx977ch3a">
            <span className={labelClass} data-id="element-260" data-mp="5yzmsnx2hkzq">Group</span>
            <select value={value.groupId} onChange={e => set("groupId", Number(e.target.value))} className={inputClass} data-id="element-261" data-mp="60klmpqezq3e">
              <option value={0} data-id="element-262" data-mp="3n97h10wa5yxs">Not assigned</option>
              {groups.map(g => <option key={g.id} value={g.id} data-id="element-263" data-mp="3s6g1j84wif27">
                  Group {g.id}
                </option>)}
            </select>
          </label> : <label className="block" data-id="element-264" data-mp="1qdjkn4ob8ia6">
            <span className={labelClass} data-id="element-265" data-mp="1qcgu4xuwghus">Program / major</span>
            <input value={value.major} onChange={e => set("major", e.target.value)} placeholder="e.g. Mechanical Engineering" className={inputClass} data-id="element-266" data-mp="1oygsi0uevys0" />
          </label>}
      </div>

      {mode === "admin" && <label className="block" data-id="element-267" data-mp="1ayxxm9qm2jxn">
          <span className={labelClass} data-id="element-268" data-mp="1azzb0kv3niij">Program / major</span>
          <input value={value.major} onChange={e => set("major", e.target.value)} className={inputClass} data-id="element-269" data-mp="27n3weg0uqi40" />
        </label>}

      <label className="block" data-id="element-270" data-mp="22pu9p84ukkjv">
        <span className={labelClass} data-id="element-271" data-mp="1xy3x0viftkpa">Role in the team</span>
        <input value={value.role} onChange={e => set("role", e.target.value)} placeholder="e.g. Hardware lead, Product, Pitch" className={inputClass} data-id="element-272" data-mp="1xwj2h5w4i1rf" />
      </label>

      <div className="grid gap-5 sm:grid-cols-2" data-id="element-273" data-mp="2qgrabor6zvft">
        <label className="block" data-id="element-274" data-mp="2lmviz55fp6tm">
          <span className={labelClass} data-id="element-275" data-mp="2lmn63d9ba1if">Email</span>
          <input type="email" value={value.email} onChange={e => set("email", e.target.value)} className={inputClass} data-id="element-276" data-mp="85twhksdudga" />
        </label>
        <label className="block" data-id="element-277" data-mp="d4wxmu58rziz">
          <span className={labelClass} data-id="element-278" data-mp="h5yoaml3f39c">LinkedIn</span>
          <input value={value.linkedin} onChange={e => set("linkedin", e.target.value)} placeholder="linkedin.com/in/…" className={inputClass} data-id="element-279" data-mp="h576qfobz622" />
        </label>
      </div>

      <label className="block" data-id="element-280" data-mp="r2btohq035jx">
        <span className={labelClass} data-id="element-281" data-mp="w2ppn1ebup1l">Short bio</span>
        <textarea rows={4} value={value.bio} onChange={e => set("bio", e.target.value)} placeholder="Background, skills and what you bring to the team" className={`${inputClass} resize-none`} data-id="element-282" data-mp="w1ekoy95bb8w" />
      </label>
    </div>;
}